var _path, _path2, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6021 13.8213C9.55574 16.2612 5.09649 16.0692 2.27252 13.2452C-0.757505 10.2152 -0.757505 5.30254 2.27252 2.27252C5.30254 -0.757506 10.2152 -0.757505 13.2452 2.27252C16.0692 5.09649 16.2612 9.55574 13.8213 12.6021L19.7475 18.5283C20.0842 18.865 20.0842 19.4108 19.7475 19.7475C19.4108 20.0842 18.865 20.0842 18.5283 19.7475L12.6021 13.8213ZM3.4917 12.026C1.13502 9.66933 1.13502 5.84839 3.4917 3.4917C5.84838 1.13502 9.66932 1.13502 12.026 3.4917C14.381 5.84666 14.3827 9.66372 12.0312 12.0208C12.0295 12.0225 12.0277 12.0243 12.026 12.026C12.0243 12.0277 12.0225 12.0294 12.0208 12.0312C9.66372 14.3827 5.84666 14.381 3.4917 12.026Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6021 13.8213C9.55574 16.2612 5.09649 16.0692 2.27252 13.2452C-0.757505 10.2152 -0.757505 5.30254 2.27252 2.27252C5.30254 -0.757506 10.2152 -0.757505 13.2452 2.27252C16.0692 5.09649 16.2612 9.55574 13.8213 12.6021L19.7475 18.5283C20.0842 18.865 20.0842 19.4108 19.7475 19.7475C19.4108 20.0842 18.865 20.0842 18.5283 19.7475L12.6021 13.8213ZM3.4917 12.026C1.13502 9.66933 1.13502 5.84839 3.4917 3.4917C5.84838 1.13502 9.66932 1.13502 12.026 3.4917C14.381 5.84666 14.3827 9.66372 12.0312 12.0208C12.0295 12.0225 12.0277 12.0243 12.026 12.026C12.0243 12.0277 12.0225 12.0294 12.0208 12.0312C9.66372 14.3827 5.84666 14.381 3.4917 12.026Z",
    fill: "url(#paint0_linear_46_1493)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.5,
    fill: "url(#paint1_linear_46_1493)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_1493",
    x1: 9.97494,
    y1: 2.31183,
    x2: 9.97493,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_46_1493",
    x1: 7.5,
    y1: 1,
    x2: 7.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B38F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.08c1f5e14f399580e46eedfaba130fd5.svg";
export { ForwardRef as ReactComponent };